import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { COMPARISON_ROWS } from '../data/content';
import { Overline } from './Overline';
export function ComparisonSection() {
  return <section className="bg-cream py-24 lg:py-32" data-id="element-162" data-mp="39ehjrr9o5p5g">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-163" data-mp="39d6chhh0lz9l">
        <div className="max-w-2xl" data-id="element-164" data-mp="34gg0p6c8tptz">
          <Overline data-id="element-165" data-mp="34f4u6yrey3z6">La diferencia</Overline>
          <h2 className="mt-6 font-serif text-[2.1rem] font-light leading-[1.1] text-ink sm:text-[2.8rem]" data-id="element-166" data-mp="2zgbjfe3igr2p">
            Lo que suele pasar vs. lo que hacemos en Lussonovo
          </h2>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-167" data-mp="2qfn1w9ews8l2">
          <div className="rounded-3xl border border-ink/10 bg-cream p-8 lg:p-10" data-id="element-168" data-mp="2qhzj2kcueex2">
            <h3 className="font-serif text-2xl font-light text-stone-600" data-id="element-169" data-mp="2lid6md4u92pb">
              Instalación tradicional
            </h3>
            <ul className="mt-8 divide-y divide-ink/10 border-t border-ink/10" data-id="element-170" data-mp="om5vf92ildrw">
              {COMPARISON_ROWS.map(row => <li key={row.traditional} className="flex items-start gap-3.5 py-4" data-id="element-171" data-mp="3ael3bkioy5f0">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-stone-400" aria-hidden="true" data-id="element-172" data-mp="3egg84yztz0xj" />
                  <span className="text-[13.5px] leading-relaxed text-stone-600" data-id="element-173" data-mp="30h6otqgbvqpc">
                    {row.traditional}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-charcoal p-8 text-cream shadow-lift lg:p-10" data-id="element-174" data-mp="3t52moyhmvonp">
            <h3 className="font-serif text-2xl font-light" data-id="element-175" data-mp="1z1gb38m5j8e">Sistema Suelo Perfecto™</h3>
            <ul className="mt-8 divide-y divide-cream/15 border-t border-cream/15" data-id="element-176" data-mp="3jfsqb6frbjts">
              {COMPARISON_ROWS.map(row => <li key={row.lussonovo} className="flex items-start gap-3.5 py-4" data-id="element-177" data-mp="3oe44tugzyiic">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" aria-hidden="true" data-id="element-178" data-mp="fykdj0zvza5x" />
                  <span className="text-[13.5px] leading-relaxed text-cream/85" data-id="element-179" data-mp="kqasjk9rqm3o">
                    {row.lussonovo}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}